import React from 'react'

export default function MarginBottom({ color = '', style = {} }) {
    let fillColor = '#7246B1'
    if (color) fillColor = color
    let className = 'icons-icon'
    return (
        <svg
            className={className}
            style={style}
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
        >
            <path
                d='M4 7V8.5C4 9.60457 4.89543 10.5 6 10.5H14C15.1046 10.5 16 9.60457 16 8.5V7'
                stroke={color}
                strokeWidth='1.25'
                strokeLinecap='round'
            />
            <path d='M7 13.5H13' stroke={color} strokeWidth='1.25' strokeLinecap='round' />
        </svg>
    )
}
